import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "sidebar sidebar-light sidebar-main sidebar-fixed sidebar-expand-md" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"sidebar-mobile-toggler text-center\"><a href=\"#\" class=\"sidebar-mobile-main-toggle\"><i class=\"icon-arrow-left8\"></i></a> Navigation <a href=\"#\" class=\"sidebar-mobile-expand\"><i class=\"icon-screen-full\"></i><i class=\"icon-screen-normal\"></i></a></div>", 1)
const _hoisted_3 = { class: "sidebar-content" }
const _hoisted_4 = { class: "card card-sidebar-mobile" }
const _hoisted_5 = {
  class: "nav nav-sidebar",
  "data-nav-type": "accordion"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-uppercase font-size-xs line-height-xs" }, "Accounts"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("i", {
    class: "icon-menu",
    title: "Accounts"
  })
], -1)
const _hoisted_7 = { class: "nav-item cursor-pointer nav-item-submenu" }
const _hoisted_8 = { class: "nav-link" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "icon-user-check" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode()
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "nav nav-group-sub" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "nav-link disabled" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode()
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createTextVNode()
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-uppercase font-size-xs line-height-xs" }, "Menü"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("i", {
    class: "icon-menu",
    title: "Main"
  })
], -1)
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["title"]
const _hoisted_25 = {
  key: 0,
  class: "nav nav-group-sub"
}
const _hoisted_26 = ["title", "onClick"]
const _hoisted_27 = { class: "nav-item mb-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "icon-exit2" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "Logout ", -1)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("li", _hoisted_7, [
            _createElementVNode("a", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", null, [
                _createElementVNode("b", null, _toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1),
                _hoisted_10,
                _hoisted_11,
                _createElementVNode("small", _hoisted_12, _toDisplayString(_ctx.user.email), 1)
              ])
            ]),
            _createElementVNode("ul", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (acc, aIndex) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: aIndex,
                  href: "#",
                  onClick: _withModifiers(($event: any) => (_ctx.changeAccount(acc)), ["prevent"]),
                  class: "nav-item cursor-pointer"
                }, [
                  _createElementVNode("a", _hoisted_15, [
                    _createElementVNode("i", {
                      class: _normalizeClass(acc.icon)
                    }, null, 2),
                    _createElementVNode("span", null, [
                      _createElementVNode("b", null, _toDisplayString(acc.firstName) + " " + _toDisplayString(acc.lastName), 1),
                      _hoisted_16,
                      _hoisted_17,
                      (acc.account!=='')
                        ? (_openBlock(), _createElementBlock("small", _hoisted_18, " (" + _toDisplayString(acc.account) + ")", 1))
                        : _createCommentVNode("", true),
                      _hoisted_19,
                      _hoisted_20,
                      _createElementVNode("small", _hoisted_21, _toDisplayString(acc.email), 1)
                    ])
                  ])
                ], 8, _hoisted_14))
              }), 128))
            ])
          ]),
          _hoisted_22,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sidebarMenu, (nav, navIndex) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: navIndex }, [
              (nav.visibility)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    class: _normalizeClass(["nav-item cursor-pointer", nav.subs?'nav-item-submenu':'']),
                    onClick: ($event: any) => (_ctx.navigateTo(nav))
                  }, [
                    _createElementVNode("a", {
                      title: nav.name,
                      class: _normalizeClass(["nav-link", [nav.routeName===_ctx.activeRoute?'active':'', nav.disabled?'disabled':'']])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(nav.icon)
                      }, null, 2),
                      _createElementVNode("span", null, _toDisplayString(nav.name), 1)
                    ], 10, _hoisted_24),
                    (nav.subs)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_25, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nav.subs, (sub, subIndex) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: subIndex,
                              class: "nav-item cursor-pointer",
                              title: sub.name,
                              onClick: ($event: any) => (_ctx.navigateTo(sub))
                            }, [
                              _createElementVNode("a", {
                                class: _normalizeClass(["nav-link", {'disabled':sub.disabled}])
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(sub.icon)
                                }, null, 2),
                                _createElementVNode("span", null, _toDisplayString(sub.name), 1)
                              ], 2)
                            ], 8, _hoisted_26))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_23))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          _createElementVNode("li", _hoisted_27, [
            _createElementVNode("a", {
              href: "#",
              title: "Logout",
              class: "nav-link",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
            }, _hoisted_30)
          ])
        ])
      ])
    ])
  ]))
}